import React from 'react'


const AdmissionCountry = props => (
    <div className="Details__Wrapper">
      <div className="Details fix">
        <div className="Details__Box">
          { props.map && <img className="map" src={ props.map.file.url } alt={ props.map.description } /> /*style={{ background:`url(${props.map.file.url}) no-repeat center` }} />*/ }
          <a style={{ padding:'6px 30px', marginTop:'6px' }} className="button" href={props.link.link}>{props.link.text}</a>
          <div className="Details__Box__Items">
            <div>
              <p>{props.title1}:</p>
              <p>{props.length}</p>
            </div>
            <div>
              <p>{props.title2}:</p>
              <p dangerouslySetInnerHTML={{ __html: props.destinations }} />
            </div>
            <div>
                  <p>{props.title3}:</p>
                  <p dangerouslySetInnerHTML={{ __html: props.tuition }} />
            </div>
            {
                props.title4 &&
                <div>
                      <p>{props.title4}:</p>
                      {
                          props.description4 &&
                          <p dangerouslySetInnerHTML={{ __html: props.description4 }} />
                      }
                </div>
            }
          </div>
          {
              props.academy &&
              <p className="disclaimer">If the $500 deposit is prohibitive you can request to be considered for a Shawn Mendes Foundation Scholarship with demonstrated need.</p>
          }
        </div>
      </div>
    </div>
)

export default AdmissionCountry



// WEBPACK FOOTER //
// ./src/components/AdmissionCountry/index.js